import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Profile_img from "./assets/images/img.jpg";
import GA_img from "./assets/images/google-analytics.png";

import MixpanelImage from "./assets/images/Mixpanel_Symbol.png";

import Cookies from "js-cookie";
import $ from "jquery";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import pako from "pako";
import AlieLogo from "./assets/images/Alie-Black.svg";
import BirthdayOverlay from "./components/BirthdayOverlay";
import MauticImage from "./assets/images/mautic_logo.png";

class Header extends Component {
	constructor(props) {
		super(props);
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		// var konvaireLoginUrl_storage = localStorage.getItem("konvaireLoginUrl");
		this.state = {
			userAuthKey: has_local_data ? localdata.user_key : "",
			apiUrl: this.decryptconfigdata("apiUrl"),
			userId: has_local_data ? localdata.user_id : "",
			//user_name: has_local_data ? localdata.user_name : '',
			//attachment: has_local_data ? localdata.attachment : '',
			//emp_first_name: has_local_data ? localdata.emp_first_name : '',
			userkey: "",
			tattleLoginUrl: "",
			atsLoginUrl: "",
			konvaireLoginUrl: "",
			// konvaireLoginUrl: konvaireLoginUrl_storage ? konvaireLoginUrl_storage : "",
			user_uuid: "",
			user_key: "",
			employeeDateOfBirth: "",
		};
		this.logout = this.logout.bind(this);
		this.ssoLoginTattle = this.ssoLoginTattle.bind(this);
		this.ssoLoginAts = this.ssoLoginAts.bind(this);
		this.loginKonvaire = this.loginKonvaire.bind(this);
		this.loginMuviAcademy = this.loginMuviAcademy.bind(this);
		this.loginMuviCommunity = this.loginMuviCommunity.bind(this);
	}
	ssoLoginTattle() {
		window.open(this.state.tattleLoginUrl, "_blank");
	}
	ssoLoginAts() {
		window.open(this.state.atsLoginUrl, "_blank");
	}
	loginKonvaire() {
		// var konvaireLoginUrl_storage = localStorage.getItem("konvaireLoginUrl");
		// var konvaireLoginUrl_cookies = Cookies.get("konvaireLoginUrl");
		//        alert(konvaireLoginUrl_storage);return false;
		window.open(this.state.konvaireLoginUrl, "_blank");
	}
	loginMuviAcademy() {
		var muviacademyLoginUrl_cookies = Cookies.get("muviacademyLoginUrl") || Cookies.get("academyLoginUrl");
		// console.log({ muviacademyLoginUrl_cookies });
		window.open(muviacademyLoginUrl_cookies, "_blank");
	}
	loginMuviCommunity() {
		var muvicommunityLoginUrl_cookies = Cookies.get("muvicommunityLoginUrl");
		window.open(muvicommunityLoginUrl_cookies, "_blank");
	}

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	logout() {
		localStorage.setItem("userLogin", "");
		localStorage.clear();
		if (Cookies.get("konvaireLoginUrl")) {
			Cookies.remove("konvaireLoginUrl", { path: "/", domain: ".muvi.com" }); // removed!
		}
		if (Cookies.get("muviacademyLoginUrl")) {
			Cookies.remove("muviacademyLoginUrl", { path: "/", domain: ".muvi.com" }); // removed!
		}
		if (Cookies.get("muvicommunityLoginUrl")) {
			Cookies.remove("muvicommunityLoginUrl", {
				path: "/",
				domain: ".muvi.com",
			}); // removed!
		}
		if (Cookies.get("muvi_useruuid")) {
			Cookies.remove("muvi_useruuid", { path: "/", domain: ".muvi.com" }); // removed!
		}
		window.location.href = "/login";
		//  window.parent.location = window.parent.location.href;
	}
	profile() {
		window.location.href = "/viewEmployee/" + this.state.userId;
	}
	getHeaderImage() {
		if (!localStorage.getItem("userLogin")) {
			window.location.href = "/login";
		}
		// var konvaireLoginUrl = Cookies.get("konvaireLoginUrl"); //localStorage.getItem('konvaireLoginUrl');
		var muviacademyLoginUrl = Cookies.get("academyLoginUrl"); //localStorage.getItem('konvaireLoginUrl');
		var muvicommunityLoginUrl = Cookies.get("muvicommunityLoginUrl"); //localStorage.getItem('konvaireLoginUrl');
		var fetchloginflg = 1;
		var muviacademyLoginflg = 0;
		var muvicommunityLoginflg = 0;
		// if (konvaireLoginUrl == null) {
		// 	var fetchloginflg = 1;
		// }
		if (muviacademyLoginUrl == null) {
			var muviacademyLoginflg = 1;
		}
		if (muvicommunityLoginUrl == null) {
			var muvicommunityLoginflg = 1;
		}
		fetch(
			this.state.apiUrl +
			"/HrmanagementRest/GetHeaderImage/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId +
			"/fetchloginflg/" +
			fetchloginflg +
			"/muviacademyLoginflg/" +
			muviacademyLoginflg +
			"/muvicommunityLoginflg/" +
			muvicommunityLoginflg,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
				//            headers: {
				//                'Accept-Encoding': 'gzip',
				//                'Content-Type': 'application/json' // Adjust content type as needed
				//            },
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				//                    findresponse = this.decompressData(buffer);

				// console.log("chk_link", findresponse);

				this.setState({
					loading: 0,
					attachment: findresponse.attachment,
					emp_start_name: findresponse.emp_start_name,
					userName: findresponse.user_name,
					user_uuid: findresponse.user_uuid,
					user_key: findresponse.user_key,
					tattleLoginUrl: findresponse.tattleLoginUrl,
					konvaireLoginUrl: findresponse.konvaireLoginUrl,
					atsLoginUrl: findresponse.atsLoginUrl,
					ats_permission: findresponse.ats_permission,
					user_permission: findresponse.user_permission,
					employeeDateOfBirth: findresponse.date_of_birth,
				});

				if (findresponse.user_permission) {
					localStorage.setItem("user_permission", findresponse.user_permission);
				}
				if (findresponse && findresponse.crm_permission) {
					localStorage.setItem("crm_permission", findresponse.crm_permission);
				} else {
					localStorage.setItem("crm_permission", 0);
				}

				// if (findresponse.konvaireLoginUrl) {
				// 	if (Cookies.get("konvaireLoginUrl") == undefined) {
				// 		let expires = new Date();
				// 		expires.setTime(expires.getTime() + 6 * 3600 * 1000);
				// 		Cookies.set("konvaireLoginUrl", findresponse.konvaireLoginUrl, {
				// 			path: "/",
				// 			domain: ".muvi.com",
				// 			expires,
				// 		});
				// 	}
				// 	localStorage.setItem("konvaireLoginUrl", findresponse.konvaireLoginUrl);
				// }
				if (findresponse.muviacademyLoginUrl) {
					if (!Cookies.get("academyLoginUrl")) {
						let expires = new Date();
						expires.setTime(expires.getTime() + 6 * 3600 * 1000);
						Cookies.set("academyLoginUrl", findresponse.muviacademyLoginUrl, {
							path: "/",
							domain: ".muvi.com",
							expires,
						});
					}
				}
				if (findresponse.muvicommunityLoginUrl) {
					if (!Cookies.get("muvicommunityLoginUrl")) {
						let expires = new Date();
						expires.setTime(expires.getTime() + 6 * 3600 * 1000);
						Cookies.set("muvicommunityLoginUrl", findresponse.muvicommunityLoginUrl, {
							path: "/",
							domain: ".muvi.com",
							expires,
						});
						//                            Cookies.set('muviacademyLoginUrl', findresponse.muviacademyLoginUrl, {path: '/', domain: '.edocent.com',expires});
					}
				}
				if (findresponse.user_uuid) {
					Cookies.set("muvi_useruuid", findresponse.user_uuid, {
						path: "/",
						domain: ".muvi.com",
					});
				}
			})
			.catch((err) => console.log(err.message));
	}
	getBreadtCome(str) {
		if (
			str == "Ticket List" ||
			str == "Add Ticket" ||
			str == "Update Ticket" ||
			str == "Ticket Detail" ||
			str == "History details"
		) {
			return <Link to="/tickets">Support</Link>;
		} else if (str == "Add Feature" || str == "View Feature" || str == "Features") {
			return <Link to="/features">Manage Feature</Link>;
		} else if (str == "Manage Filter") {
			return <Link to="/er">ER</Link>;
		} else if (str == "SLA List") {
			return <Link to="/SlaList">SLA</Link>;
		} else if (str == "Edit SLA") {
			return <Link to="/SlaList">SLA</Link>;
		} else if (str == "Add SLA") {
			return <Link to="/SlaList">SLA</Link>;
		} else if (str == "SLA Dashboard") {
			return <Link to="/SlaList">SLA</Link>;
		} else if (str == "Masters") {
			return <Link to="/masters">HR Admin</Link>;
		} else if (str == "Ask" ||
			str == "Train" ||
			str == "Eval") {
			return <Link to="/alie">Alie</Link>;
		} else if (str == "Eval Details" ||
			str == "Eval") {
			return <Link to="/eval">Eval</Link>;
		} else if (
			str == "Employees" ||
			str == "Groups" ||
			str == "Peer Review" ||
			str == "Organization chart" ||
			str == "Attendance" ||
			str == "Snippets" ||
			str == "OKR" ||
			str == "Activity Insights" ||
			str == localStorage.getItem("quizTitle")
		) {
			return <Link to="/employees">Employee</Link>;
		} else if (str == "Add OKR" || str == "OKR Details") {
			return <Link to="/listokr">OKR</Link>;
		} else if (str == "Add Employee") {
			return <Link to="/addEmployee">Employee</Link>;
		} else if (str == "Add Employee") {
			return <Link to="/addEmployee">Employee</Link>;
		} else if (str == "Employee Details") {
			return <Link to="/employees">Employee</Link>;
		} else if (str == "Leaves") {
			return <Link to="/leaves">HR Admin</Link>;
		} else if (str == "Rewards") {
			return <Link to="/rewards">HR Admin</Link>;
		} else if (str == "Leave Application") {
			return <Link to="/leaveRequests">HR Admin</Link>;
		} else if (str == "Leave Balances") {
			return <Link to="/leavesByEmployee">HR Admin</Link>;
		} else if (str == "Leave Requests") {
			return <Link to="/leaveRequests">HR Admin</Link>;
		} else if (str == "Leave Lops") {
			return <Link to="/leaves">HR Admin</Link>;
		} else if (str == "Candidate Details") {
			return <Link to="/hiring">Hiring</Link>;
		} else if (str == "Add Candidate") {
			return <Link to="/hiring">Hiring</Link>;
		} else if (str == "Edit Candidate") {
			return <Link to="/hiring">Hiring</Link>;
		} else if (str == "All Partners") {
			return <Link to="/allreseller">Partners</Link>;
		} else if (str == "Referrer") {
			return <Link to="/allreseller">Partners</Link>;
		} else if (str == "Reseller") {
			return <Link to="/allreseller">Partners</Link>;
		} else if (str == "Contact Us") {
			return <Link to="/ContactUs">Extranet Forms</Link>;
		} else if (str == "Walkin") {
			return <Link to="/Walkin">Extranet Forms</Link>;
		} else if (str == "Partner Contacts") {
			return <Link to="/PartnerContact">Extranet Forms</Link>;
		} else if (str == "Pdf Downloads") {
			return <Link to="/pdfDownloads">Extranet Forms</Link>;
		} else if (str == "Migration Request") {
			return <Link to="/migrationrequest">Extranet Forms</Link>;
		} else if (str == "Live Demo") {
			return <Link to="/livedemoRequests">Extranet Forms</Link>;
		} else if (str == "Hackathon") {
			return <Link to="/hackathon">Extranet Forms</Link>;
		} else if (str == "Template Purchase Request") {
			return <Link to="/templatepurchaserequest">Extranet Forms</Link>;
		} else if (str == "All Products Request") {
			return <Link to="/allproductsrequest">Extranet Forms</Link>;
		} else if (str == "Webinar Registration") {
			return <Link to="/AllwebinarRequest">Extranet Forms</Link>;
		} else if (str == "Muvi Ultimate") {
			return <Link to="/MuviUltimate">Extranet Forms</Link>;
		} else if (str == "Ask Sales") {
			return <Link to="/ask-sales/list">Extranet Forms</Link>;
		} else if (str == "Sanjh Request") {
			return <Link to="/sanjhrequest">Extranet Forms</Link>;
		} else if (str == "joinmuvitv") {
			return <Link to="/joinmuvitv">Extranet Forms</Link>;
		}else if (str == "upcwebinar") {
			return <Link to="/upcwebinar">Extranet Forms</Link>;
		} else if (str == "rfp") {
			return <Link to="/rfp">Extranet Forms</Link>;
		} else if (str == "All Request") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Chat Transcript") {
			return <Link to="/liveChat">LiveChat</Link>;
		} else if (str == "Edit Chat Transcript") {
			return <Link to="/liveChat">Live Chat</Link>;
		} else if (str == "Live Chat") {
			return <Link to="/liveChat">Leads</Link>;
		} else if (str == "Live Chat Transcript") {
			return <Link to="/chats/list">Leads</Link>;
		} else if (str == "Edit Chat Detail") {
			return <Link to="/liveChat">Live Chat</Link>;
		} else if (str == "Chat History Revision") {
			return <Link to="/liveChat">Live Chat</Link>;
		} else if (str == "Snippet Detail") {
			return <Link to="/snippets">Snippets</Link>;
		} else if (str == "Add Request") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Kanban") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Create Request") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Request Detail") {
			return <Link to="/er">ER</Link>;
		} else if (str == "History Revision") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Story Detail") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Customersrevenue") {
			return <Link to="/revenue">Revenue</Link>;
		} else if (str == "Resellers" || str == "Customer") {
			return <Link to="/revenue">Revenue</Link>;
		} else if (str == "Products") {
			return <Link to="/products">Product Dashboard</Link>;
		} else if (
			str == "Enterprise" ||
			str == "All" ||
			str == "Cancelled" ||
			str == "Deleted" ||
			str == "Demo" ||
			str == "Leads" ||
			str == "Muvi Free" ||
			str == "Customers Details" ||
			str == "Customers"
		) {
			return <Link to="/test/customers">Customer</Link>;
		} else if (str == "Edit Request") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Clone Request") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Clone Story") {
			return <Link to="/er">ER</Link>;
		} else if (str == "Note Detail") {
			return <Link to="/er">ER</Link>;
		} else if (
			str == "Enterprise" ||
			str == "All" ||
			str == "Cancelled" ||
			str == "Deleted" ||
			str == "Demo" ||
			str == "Leads" ||
			str == "Muvi Free" ||
			str == "Customers Details" ||
			str == "Customers"
		) {
			return <Link to="/test/customers">customers</Link>;
		} else if (
			str == "Add Todo" ||
			str == "Todo List" ||
			str == "Todo History" ||
			str == "Update Todo" ||
			str == "Todo Detail"
		) {
			return <Link to="/todos">Todo</Link>;
		} else if (str == "Customer Success" || str == "Password change") {
			return <Link to="/customerSuccess">Customer Success</Link>;
		} else if (str == "Add Snippets") {
			return <Link to="/snippets">Snippets</Link>;
		} else if (str == "Edit OKR") {
			return <Link to="/listokr">OKR</Link>;
		} else if (str == "View OKR") {
			return <Link to="/listokr">OKR</Link>;
		} else if (str == "Live Chat Transcript") {
			return <Link to="/chats">Leads</Link>;
		} else if (str == "Accounts") {
			return <Link to="/accounts/list"> CRM</Link>;
		} else if (str == "Account Details") {
			return <Link to="/accounts/list"> Accounts</Link>;
		} else if (str == "Stream Info") {
			return <Link to="/stream/info">Stream Info</Link>;
		} else if (str == "Deals") {
			return <Link to="/accounts/list">CRM</Link>;
		} else if (str == "Edit Deal") {
			return <Link to="/deals/list">Deal</Link>;
		} else if (str == "Add Deal") {
			return <Link to="/deals/list">Deal</Link>;
		} else if (str == "Contact Details") {
			return <Link to="/contacts/list">Contacts</Link>;
		} else if (str == "Contacts") {
			return <Link to="/contacts/list">CRM</Link>;
		} else if (str == "Contact") {
			return <Link to="#">Contact</Link>;
		} else if (str == "CRM") {
			return <Link to="#">CRM</Link>;
		}
	}
	componentDidMount() {
		this.getHeaderImage();
		$(document).ready(function () {
			$("#menu_toggle").on("click", function () {
				if ($("body").hasClass("nav-md")) {
					$("#sidebar-menu").find("li.active ul").hide();
					$("#sidebar-menu").find("li.active").addClass("active-sm").removeClass("active");
				} else {
					$("#sidebar-menu").find("li.active-sm ul").show();
					$("#sidebar-menu").find("li.active-sm").addClass("active").removeClass("active-sm");
				}
				if ($(".col-md-3.left_col").hasClass("active")) {
					$(".col-md-3.left_col").removeClass("active");
				} else {
					$(".col-md-3.left_col").addClass("active");
				}
				$("body").toggleClass("nav-md nav-sm");

				$(".dataTable").each(function () {
					$(this).dataTable().fnDraw();
				});
			});
			$(".nav-overlay").on("click", function () {
				$(".col-md-3.left_col").removeClass("active");
			});
			$(".side-menu li a").on("click", function () {
				$(".col-md-3.left_col").removeClass("active");
			});
			$(".side-menu li a.dropdown-toggle").on("click", function () {
				$(".col-md-3.left_col").addClass("active");
			});
			$(".fa-calendar").click(function () {
				$(this).parent().find("input").click();
			});
			$("#sidebar-menu li").on("click", function () {
				$(this).parent().find("li.current-page").removeClass("current-page");
				$(this).addClass("current-page");
			});
		});
	}
	render() {
		return (
			<div class="top_nav">
				<div class="nav_menu">
					<nav>
						<div class="nav toggle">
							<a id="menu_toggle">
								<i class="fal fa-bars"></i>
							</a>
						</div>
						 <div class="top_nav_title">
									  <h4>
										{this.props.brecum_page === "" || !this.props.brecum_page
										  ? "Dashboard"
										  : this.props.brecum_page}
									  </h4>
									  <h6 class="hidden-sm">
										<Link to="/home">Home</Link>
										<span>
										  {this.props.brecum_main && this.props.brecum_main != ""
											? " > "
											: ""}
										</span>
										{this.props.brecum_main != ""
										  ? this.getBreadtCome(this.props.brecum_main)
										  : ""}
						
										<span>{this.props.brecum_name != "" ? " > " : ""}</span>
										{this.getBreadtCome(this.props.brecum_name)}
						
										<span> {this.props.brecum_page != "" ? " > " : ""} </span>
										{this.props.brecum_page}
									  </h6>
									</div>
						<ul class="nav navbar-nav navbar-right">
							<li class="vertleft">
								<Link to="/alie" className="alie-logo">
									<img src={AlieLogo} alt="Alie" style={{ height: '30px' }} />
								</Link>
							</li>
							<li class="vertleft">
								<a
									href="javascript:;"
									class="user-profile dropdown-toggle"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<span class="pro_name">
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M4.16634 4.99998C4.62658 4.99998 4.99967 4.62688 4.99967 4.16665C4.99967 3.70641 4.62658 3.33331 4.16634 3.33331C3.7061 3.33331 3.33301 3.70641 3.33301 4.16665C3.33301 4.62688 3.7061 4.99998 4.16634 4.99998Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M4.16634 10.8333C4.62658 10.8333 4.99967 10.4602 4.99967 10C4.99967 9.53978 4.62658 9.16669 4.16634 9.16669C3.7061 9.16669 3.33301 9.53978 3.33301 10C3.33301 10.4602 3.7061 10.8333 4.16634 10.8333Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M4.16634 16.6667C4.62658 16.6667 4.99967 16.2936 4.99967 15.8333C4.99967 15.3731 4.62658 15 4.16634 15C3.7061 15 3.33301 15.3731 3.33301 15.8333C3.33301 16.2936 3.7061 16.6667 4.16634 16.6667Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M10.0003 4.99998C10.4606 4.99998 10.8337 4.62688 10.8337 4.16665C10.8337 3.70641 10.4606 3.33331 10.0003 3.33331C9.54009 3.33331 9.16699 3.70641 9.16699 4.16665C9.16699 4.62688 9.54009 4.99998 10.0003 4.99998Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M10.0003 10.8333C10.4606 10.8333 10.8337 10.4602 10.8337 10C10.8337 9.53978 10.4606 9.16669 10.0003 9.16669C9.54009 9.16669 9.16699 9.53978 9.16699 10C9.16699 10.4602 9.54009 10.8333 10.0003 10.8333Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M10.0003 16.6667C10.4606 16.6667 10.8337 16.2936 10.8337 15.8333C10.8337 15.3731 10.4606 15 10.0003 15C9.54009 15 9.16699 15.3731 9.16699 15.8333C9.16699 16.2936 9.54009 16.6667 10.0003 16.6667Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M15.8333 4.99998C16.2936 4.99998 16.6667 4.62688 16.6667 4.16665C16.6667 3.70641 16.2936 3.33331 15.8333 3.33331C15.3731 3.33331 15 3.70641 15 4.16665C15 4.62688 15.3731 4.99998 15.8333 4.99998Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M15.8333 10.8333C16.2936 10.8333 16.6667 10.4602 16.6667 10C16.6667 9.53978 16.2936 9.16669 15.8333 9.16669C15.3731 9.16669 15 9.53978 15 10C15 10.4602 15.3731 10.8333 15.8333 10.8333Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M15.8333 16.6667C16.2936 16.6667 16.6667 16.2936 16.6667 15.8333C16.6667 15.3731 16.2936 15 15.8333 15C15.3731 15 15 15.3731 15 15.8333C15 16.2936 15.3731 16.6667 15.8333 16.6667Z"
												stroke="white"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
										</svg>
									</span>
								</a>
								<ul class="dropdown-menu dropdown-usermenu pull-left nw-navproduct">
									<div>
										<ul class="inner-nw-navproduct">
											<li>
												<a onClick={this.ssoLoginTattle}>
													<span>
														{/* icon and colour change */}
														<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 120 131" fill="none">
															<path d="M25.1707 10.3843C33.9116 8.05346 47.6615 16.9188 54.6543 20.9979C70.9709 30.9041 85.3157 38.6908 100.648 50.4836C107.723 56.3802 114.998 65.6166 105.364 75.2491C101.286 79.3282 101.785 79.9387 98.2887 77.6081C86.4957 70.5316 61.9817 54.4369 49.7446 46.8618C45.0825 43.9481 39.3214 41.0491 34.6048 45.7661C31.0667 54.0213 37.6162 56.4219 42.8607 59.9183C53.3499 66.9111 63.0333 71.7948 73.5227 78.7867C75.8809 80.359 87.6748 86.4871 87.6748 89.4009C88.2574 91.1493 81.7643 95.8943 80.5985 96.4765C77.6852 98.2249 74.9696 101.194 71.1637 100.015C63.0413 97.4969 54.2549 89.9419 47.8447 85.8632C42.2377 82.2948 36.0513 84.6837 34.872 85.8632C30.1547 90.5803 34.2196 94.6448 34.872 95.297C35.7112 96.1363 56.4153 107.118 55.8326 109.449C55.8326 111.197 49.9223 114.763 48.7567 115.346C44.0952 118.259 41.0286 118.898 35.7841 120.063C22.964 122.977 15.1249 116.983 13.3768 105.911C9.88035 84.9336 8.95328 55.6022 11.2842 34.6245C13.0323 25.301 13.5161 12.7152 25.1707 10.3843Z" fill="#006EFA"></path>
														</svg>
													</span>
													<label>Tattle</label>
												</a>
											</li>

											<li>
												<a onClick={this.loginKonvaire}>
													<span>
														{/* icon and colour change */}
														<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 120 131" fill="none">
															<path d="M25.1707 10.3843C33.9116 8.05346 47.6615 16.9188 54.6543 20.9979C70.9709 30.9041 85.3157 38.6908 100.648 50.4836C107.723 56.3802 114.998 65.6166 105.364 75.2491C101.286 79.3282 101.785 79.9387 98.2887 77.6081C86.4957 70.5316 61.9817 54.4369 49.7446 46.8618C45.0825 43.9481 39.3214 41.0491 34.6048 45.7661C31.0667 54.0213 37.6162 56.4219 42.8607 59.9183C53.3499 66.9111 63.0333 71.7948 73.5227 78.7867C75.8809 80.359 87.6748 86.4871 87.6748 89.4009C88.2574 91.1493 81.7643 95.8943 80.5985 96.4765C77.6852 98.2249 74.9696 101.194 71.1637 100.015C63.0413 97.4969 54.2549 89.9419 47.8447 85.8632C42.2377 82.2948 36.0513 84.6837 34.872 85.8632C30.1547 90.5803 34.2196 94.6448 34.872 95.297C35.7112 96.1363 56.4153 107.118 55.8326 109.449C55.8326 111.197 49.9223 114.763 48.7567 115.346C44.0952 118.259 41.0286 118.898 35.7841 120.063C22.964 122.977 15.1249 116.983 13.3768 105.911C9.88035 84.9336 8.95328 55.6022 11.2842 34.6245C13.0323 25.301 13.5161 12.7152 25.1707 10.3843Z" fill="#006EFA"></path>
														</svg>
													</span>
													<label>Konviare</label>
												</a>
											</li>
											<li>
												<a
													href="https://analytics.google.com/analytics/web/#/p337393401/reports/intelligenthome"
													target="_blank"
												>
													<span>
														<img src={GA_img} />
													</span>
													<label style={{ marginTop: "4px" }}>GA</label>
												</a>
											</li>
										</ul>
									</div>
									<div>
										<ul class="inner-nw-navproduct">

											<li>
												<a onClick={this.loginMuviAcademy}>
													<span>
														{/* icon and colour change */}
														<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 120 131" fill="none">
															<path d="M25.1707 10.3843C33.9116 8.05346 47.6615 16.9188 54.6543 20.9979C70.9709 30.9041 85.3157 38.6908 100.648 50.4836C107.723 56.3802 114.998 65.6166 105.364 75.2491C101.286 79.3282 101.785 79.9387 98.2887 77.6081C86.4957 70.5316 61.9817 54.4369 49.7446 46.8618C45.0825 43.9481 39.3214 41.0491 34.6048 45.7661C31.0667 54.0213 37.6162 56.4219 42.8607 59.9183C53.3499 66.9111 63.0333 71.7948 73.5227 78.7867C75.8809 80.359 87.6748 86.4871 87.6748 89.4009C88.2574 91.1493 81.7643 95.8943 80.5985 96.4765C77.6852 98.2249 74.9696 101.194 71.1637 100.015C63.0413 97.4969 54.2549 89.9419 47.8447 85.8632C42.2377 82.2948 36.0513 84.6837 34.872 85.8632C30.1547 90.5803 34.2196 94.6448 34.872 95.297C35.7112 96.1363 56.4153 107.118 55.8326 109.449C55.8326 111.197 49.9223 114.763 48.7567 115.346C44.0952 118.259 41.0286 118.898 35.7841 120.063C22.964 122.977 15.1249 116.983 13.3768 105.911C9.88035 84.9336 8.95328 55.6022 11.2842 34.6245C13.0323 25.301 13.5161 12.7152 25.1707 10.3843Z" fill="#006EFA"></path>
														</svg>
													</span>
													<label>Academy</label>
												</a>
											</li>
											<li>
												<a onClick={this.loginMuviCommunity}>
													<span>
														{/* icon and colour change */}
														<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 120 131" fill="none">
															<path d="M25.1707 10.3843C33.9116 8.05346 47.6615 16.9188 54.6543 20.9979C70.9709 30.9041 85.3157 38.6908 100.648 50.4836C107.723 56.3802 114.998 65.6166 105.364 75.2491C101.286 79.3282 101.785 79.9387 98.2887 77.6081C86.4957 70.5316 61.9817 54.4369 49.7446 46.8618C45.0825 43.9481 39.3214 41.0491 34.6048 45.7661C31.0667 54.0213 37.6162 56.4219 42.8607 59.9183C53.3499 66.9111 63.0333 71.7948 73.5227 78.7867C75.8809 80.359 87.6748 86.4871 87.6748 89.4009C88.2574 91.1493 81.7643 95.8943 80.5985 96.4765C77.6852 98.2249 74.9696 101.194 71.1637 100.015C63.0413 97.4969 54.2549 89.9419 47.8447 85.8632C42.2377 82.2948 36.0513 84.6837 34.872 85.8632C30.1547 90.5803 34.2196 94.6448 34.872 95.297C35.7112 96.1363 56.4153 107.118 55.8326 109.449C55.8326 111.197 49.9223 114.763 48.7567 115.346C44.0952 118.259 41.0286 118.898 35.7841 120.063C22.964 122.977 15.1249 116.983 13.3768 105.911C9.88035 84.9336 8.95328 55.6022 11.2842 34.6245C13.0323 25.301 13.5161 12.7152 25.1707 10.3843Z" fill="#006EFA"></path>
														</svg>
													</span>
													<label>Community</label>
												</a>
											</li>
											<li>
												<a
													href="https://mixpanel.com/login/"
													target="_blank"
												>
													<span>
														<img src={MixpanelImage} />
													</span>
													<label style={{ marginTop: "4px" }}>MixPanel</label>
												</a>
											</li>
										</ul>
									</div>
									<div>
										<ul class="inner-nw-navproduct">
											<li>
												<a
													href={`${process.env.REACT_APP_CRM_ADMIN}/sso/${this.state.userAuthKey}`}
													target="_blank"
													rel="noreferrer"
												>
													<span>
														<img
															style={{ width: "24px", height: "24px" }}
															src={MauticImage}
														/>
													</span>
													<label style={{ marginTop: "4px" }}>Mautic</label>
												</a>
											</li>
											{this.state.ats_permission == "yes" ? (
												<li>
													<a onClick={() => this.ssoLoginAts()}>
														<span>
															{/* icon and colour change */}
															<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 120 131" fill="none">
																<path d="M25.1707 10.3843C33.9116 8.05346 47.6615 16.9188 54.6543 20.9979C70.9709 30.9041 85.3157 38.6908 100.648 50.4836C107.723 56.3802 114.998 65.6166 105.364 75.2491C101.286 79.3282 101.785 79.9387 98.2887 77.6081C86.4957 70.5316 61.9817 54.4369 49.7446 46.8618C45.0825 43.9481 39.3214 41.0491 34.6048 45.7661C31.0667 54.0213 37.6162 56.4219 42.8607 59.9183C53.3499 66.9111 63.0333 71.7948 73.5227 78.7867C75.8809 80.359 87.6748 86.4871 87.6748 89.4009C88.2574 91.1493 81.7643 95.8943 80.5985 96.4765C77.6852 98.2249 74.9696 101.194 71.1637 100.015C63.0413 97.4969 54.2549 89.9419 47.8447 85.8632C42.2377 82.2948 36.0513 84.6837 34.872 85.8632C30.1547 90.5803 34.2196 94.6448 34.872 95.297C35.7112 96.1363 56.4153 107.118 55.8326 109.449C55.8326 111.197 49.9223 114.763 48.7567 115.346C44.0952 118.259 41.0286 118.898 35.7841 120.063C22.964 122.977 15.1249 116.983 13.3768 105.911C9.88035 84.9336 8.95328 55.6022 11.2842 34.6245C13.0323 25.301 13.5161 12.7152 25.1707 10.3843Z" fill="#006EFA"></path>
															</svg>
														</span>
														<label>ATS</label>
													</a>
												</li>
											) : (
												""
											)}

										</ul>
									</div>

								</ul>
							</li>
							<li class="vertleft">
								<a
									href="javascript:;"
									class="user-profile dropdown-toggle"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									{this.props.profileImg ? (
										<img src={this.props.profileImg} />
									) : this.state.attachment ? (
										<img src={this.state.attachment} />
									) : (
										<span class="profile_first_name">{this.state.emp_start_name}</span>
									)}
									<span class="pro_name text-inded">{this.state.userName}</span>
									<span class="icon-f fal fa-angle-down"></span>
								</a>

								<ul className="dropdown-menu dropdown-usermenu pull-left nw-navprofile">
									<li>
										<Link to={`/viewEmployee/${this.state.userId}`}>
											<span>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M13.3331 14V12.6667C13.3331 11.9594 13.0522 11.2811 12.5521 10.781C12.052 10.281 11.3737 10 10.6665 10H5.33317C4.62593 10 3.94765 10.281 3.44755 10.781C2.94746 11.2811 2.6665 11.9594 2.6665 12.6667V14"
														stroke="#5C5F62"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
													<path
														d="M8.00016 7.33333C9.47292 7.33333 10.6669 6.13943 10.6669 4.66667C10.6669 3.19391 9.47292 2 8.00016 2C6.5274 2 5.3335 3.19391 5.3335 4.66667C5.3335 6.13943 6.5274 7.33333 8.00016 7.33333Z"
														stroke="#5C5F62"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
												</svg>
											</span>
											Profile
										</Link>
									</li>
									<li>
										<button class="download" onClick={this.logout}>
											<span>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M12.6667 7.33331H3.33333C2.59695 7.33331 2 7.93027 2 8.66665V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V8.66665C14 7.93027 13.403 7.33331 12.6667 7.33331Z"
														stroke="#5C5F62"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
													<path
														d="M4.6665 7.33331V4.66665C4.6665 3.78259 5.01769 2.93475 5.64281 2.30962C6.26794 1.6845 7.11578 1.33331 7.99984 1.33331C8.88389 1.33331 9.73174 1.6845 10.3568 2.30962C10.9819 2.93475 11.3331 3.78259 11.3331 4.66665V7.33331"
														stroke="#5C5F62"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
												</svg>
											</span>
											Logout
										</button>
									</li>
								</ul>
							</li>

							<li role="presentation" class="dropdown hidden">
								<a
									href="javascript:;"
									class="dropdown-toggle info-number"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<i class="fa fa-bell"></i>
									<span class="badge bg-black">6</span>
								</a>
								<ul id="menu1" class="dropdown-menu list-unstyled msg_list" role="menu">
									<li>
										<a>
											<span class="image">
												<img src={Profile_img} alt="Profile Image" />
											</span>
											<span>
												<span>John Smith</span>
												<span class="time">3 mins ago</span>
											</span>
											<span class="message">
												Film festivals used to be do-or-die moments for movie makers. They were
												where...
											</span>
										</a>
									</li>
									<li>
										<a>
											<span class="image">
												<img src={Profile_img} alt="Profile Image" />
											</span>
											<span>
												<span>John Smith</span>
												<span class="time">3 mins ago</span>
											</span>
											<span class="message">
												Film festivals used to be do-or-die moments for movie makers. They were
												where...
											</span>
										</a>
									</li>
									<li>
										<a>
											<span class="image">
												<img src={Profile_img} alt="Profile Image" />
											</span>
											<span>
												<span>John Smith</span>
												<span class="time">3 mins ago</span>
											</span>
											<span class="message">
												Film festivals used to be do-or-die moments for movie makers. They were
												where...
											</span>
										</a>
									</li>
									<li>
										<a>
											<span class="image">
												<img src={Profile_img} alt="Profile Image" />
											</span>
											<span>
												<span>John Smith</span>
												<span class="time">3 mins ago</span>
											</span>
											<span class="message">
												Film festivals used to be do-or-die moments for movie makers. They were
												where...
											</span>
										</a>
									</li>
									<li>
										<div class="text-center">
											<a>
												<strong>See All Alerts</strong>
												<i class="fa fa-angle-right"></i>
											</a>
										</div>
									</li>
								</ul>
							</li>
						</ul>
					</nav>

					{this.state.employeeDateOfBirth && (
						<BirthdayOverlay
							dob={this.state.employeeDateOfBirth}
						/>
					)}

				</div>
			</div>
		);
	}
}
export default Header;



// WEBPACK FOOTER //
// ./src/Header.js